import HtmlWebpackExternalsPlugin from './HtmlWebpackExternalsPlugin'

export default HtmlWebpackExternalsPlugin
